import { Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import { getAggregationType, getDimensionAggregationType } from "../../../../../utilities/aggregationHelper.ts";
import { isDateAggregationField } from "../../../../../utilities/fieldsHelper.ts";
import PrimaryCaption from "./PrimaryCaption.tsx";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  field: ReportField;
}
export default function FieldDimensionCaption({ field }: Props) {
  const caption = field.config.customLabel || field.config.systemLabel || field.meta.caption;
  const aggregation = getDimensionAggregationType(field);

  const CaptionElement = useMemo(() => <PrimaryCaption text={caption} />, [caption]);

  if (aggregation && !field.config.persistedAggregationName && !isDateAggregationField(field)) {
    return (
      <Grid
        sx={{
          gap: 0.5,
          overflow: "hidden",
          alignItems: "center",
          display: "grid",
          gridTemplateColumns: "minmax(0, auto) minmax(20px, auto)",
        }}
      >
        <Typography variant="caption" noWrap sx={{ fontWeight: 500, color: (theme) => theme.palette.primary.main }}>
          {getAggregationType(aggregation)?.short} of
        </Typography>
        {CaptionElement}
      </Grid>
    );
  }

  return <>{CaptionElement} </>;
}
